<template>
    <v-container
        fluid
        pa-0
    >
        <v-layout
            row
            wrap
        >
            <v-flex
                xs12
                sm6
            >
                <v-img
                    src="/images/packing-000.jpg"
                />
                <div class="body-2 my-2">
                    Properly Positioned Material
                </div>
            </v-flex>
            <v-flex
                xs12
                sm6
            >
                <v-img
                    src="/images/packing-001.jpg"
                />
                <div class="body-2 my-2">
                    Stretch Wrap Support
                </div>
            </v-flex>
            <v-flex
                xs12
                sm6
            >
                <v-img
                    src="/images/packing-002.jpg"
                />
                <div class="body-2 my-2">
                    Securing Material to Base of Pallet
                </div>
            </v-flex>
            <v-flex
                xs12
                sm6
            >
                <v-img
                    src="/images/packing-003.jpg"
                />
                <div class="body-2 my-2">
                    Fully Wrapping All Material and Pallet
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>
